export enum GeneralTenantCaseTypeEnum {
	BETRIEBSKOSTENABRECHNUNG = 'Betriebskostenabrechnung',
	MIETERHOEHUNG = 'Mieterhöhung',
	KUENDIGUNG_VERMIETER = 'Kündigung durch den Vermieter',
	KAUTION = 'Kaution',
	SCHOENHEITSREPERATUREN = 'Schönheitsreparaturen',
	MODERNISIERUNG = 'Modernisierung',
	SONSTIGE = 'Sonstige',
}
